import GettingStarted from "./Onboarding";
export default GettingStarted;
